<div class="headert_yhy">
  <div class="drt_section">
    <div class="mat_poo">
  <div class="drg_se_ctionm">
    <button  (click)="toggleSidebar()">
      <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="menu"></mat-icon>
    </button>
    <span class="mx-3 d-none d-md-block">
       <a [routerLink]="['/dashboard']" >
      <img src="../assets/images/new-lookzup-business-logo.png" alt="" srcset="" />
      </a>
    </span>
    <span class="mobile_logo_mt mx-3 d-block d-md-none">
      <a [routerLink]="['/dashboard']" >
      <img src="../../../../assets/images/lookzup-logo-small.png" alt="" srcset="" />
    </a>
    </span>
  </div>
</div>
<!------------ WARNING ------------ DO NOT DELETE ------------ WARNING ------------>
<!-- <div class="mat_poo d-none d-md-block">
  <div class="search-field">
      <input
      [(ngModel)]="searchKey"
      (keyup.enter)="search()"
        matInput
        type="text"
        placeholder="Search other businesses in the platform"
      />
      <button
          mat-button
          matSuffix
          
          aria-label="search"
        >
          <mat-icon>search</mat-icon>
        </button>
  </div>
  </div>  -->
<!------------ WARNING ------------ DO NOT DELETE ------------ WARNING ------------>
<!-- 
  <div class="language_drop_select">
    <mat-form-field appearance="outline" style="width: 150px;" >
      <mat-select [(ngModel)]="selectLanguage">
        <mat-option value="English">
          English
        </mat-option>
        <mat-option value="हिंदी">
          हिंदी
        </mat-option>
        <mat-option value="Bengali">
          বাংলা
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->

<div class="mat_poo">
<div class="headert_thtas">
  
  <!-- <div class="ht_sectionm d-none d-md-block">
    <button mat-icon-button class="profile_button " [matMenuTriggerFor]="menu4">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="m483.328 137.952-1.664.736c-37.312 16.608-76.064 28.672-115.808 36.608a391.016 391.016 0 0 1-.064 161.568c39.744 7.904 78.688 19.872 115.84 36.416l1.632.736C501.536 338.656 512 298.592 512 256s-10.464-82.656-28.672-118.048zM186.112 363.168c14.144 45.024 37.472 87.68 69.856 125.376 32.384-37.696 55.744-80.352 69.856-125.376-46.368-6.144-93.344-6.112-139.712 0zM334.144 180.288c-25.728 3.616-51.712 6.08-78.144 6.08-26.464 0-52.448-2.496-78.176-6.08-10.784 49.984-10.784 101.696.064 151.68a567.42 567.42 0 0 1 156.192 0 358.057 358.057 0 0 0 .064-151.68zM255.968 23.456c-32.384 37.696-55.712 80.352-69.856 125.408a534.563 534.563 0 0 0 139.712 0c-14.144-45.024-37.472-87.712-69.856-125.408zM278.048 0c37.568 43.008 64.32 92.064 79.872 143.872 37.312-7.296 73.856-18.4 108.736-33.792C424.416 48.672 356.256 6.72 278.048 0zM45.312 110.08c34.912 15.36 71.456 26.496 108.736 33.792C169.6 92.064 196.352 43.008 233.92 0 155.712 6.72 87.584 48.672 45.312 110.08zM146.144 175.328c-39.744-7.968-78.464-20-115.744-36.608l-1.664-.736C10.464 173.344 0 213.408 0 256s10.464 82.656 28.736 118.048l1.664-.736c37.12-16.576 76.064-28.544 115.808-36.416-11.296-53.248-11.296-108.288-.064-161.568zM154.048 368.16c-37.312 7.264-73.856 18.4-108.736 33.76C87.584 463.328 155.712 505.28 233.92 512c-37.568-43.008-64.32-92.064-79.872-143.84zM357.92 368.128C342.4 419.936 315.616 468.992 278.048 512c78.208-6.72 146.368-48.672 188.608-110.08-34.88-15.392-71.424-26.496-108.736-33.792z" fill="#1f1f1f" opacity="1" data-original="#000000" class=""></path></g></svg>
    </button>
    <mat-menu #menu4="matMenu">
      <button mat-menu-item>
      <span class="menu_text">English</span></button>
      <button mat-menu-item>
        <span class="menu_text"> हिंदी </span></button>
        <button mat-menu-item>
          <span class="menu_text">বাংলা </span></button>
      </mat-menu>
    </div> -->

 <div>
 <button mat-icon-button class="profile_button" (click)="openmessages()">
  <span class="hyt_sectionmessage" *ngIf="notificationMessageCountData?.unread_messages > 0"></span>
  <mat-icon class="material-icons">chat</mat-icon>
</button>
</div>
<div>
    <button mat-icon-button class="profile_button" (click)="opennotification()">
      <span class="hyt_section" *ngIf="notificationMessageCountData?.unread_notifications > 0"></span>
      <mat-icon class="material-icons">notifications</mat-icon>
    </button>
</div>
<!-- <div>
  <button mat-icon-button [matMenuTriggerFor]="menu1" class="profile_button">
    <mat-icon class="material-icons">add_circle</mat-icon>
    </button>
</div> -->
<div>
    <button mat-icon-button [matMenuTriggerFor]="menu" class="profile_button">
      <mat-icon class="material-icons">more_vert</mat-icon>
      </button>
</div>

    <mat-menu #menu="matMenu" class="derop">
      <button mat-menu-item (click)="openProfile()">
        <mat-icon class="material-icons-outlined">account_circle</mat-icon>
      <span class="menu_text">Personal Profile</span></button>
      <button mat-menu-item (click)="openbusinessprofile()">
        <mat-icon class="material-icons-outlined">insert_chart</mat-icon>
      <span class="menu_text">Business profile</span></button>
      <button mat-menu-item (click)="openemaployeeprofile()">
        <mat-icon class="material-icons-outlined">work_outline</mat-icon>
      <span class="menu_text">Employee profile</span></button>
      <!-- <button mat-menu-item (click)="openChangeNumber()">  
        <mat-icon class="material-icons-outlined">phonelink_setup</mat-icon>
      <span class="menu_text">Change phone number</span></button> -->
      <!-- <button mat-menu-item><mat-icon class="material-icons-outlined">location_on</mat-icon>
        <span class="menu_text">Change location</span></button> -->
      <button mat-menu-item (click)="openPrivacySettings()">
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        <span class="menu_text">Account Settings</span></button>
        <button mat-menu-item (click)="openrecharge()">
          <mat-icon class="material-icons-outlined">payments</mat-icon>
          <span class="menu_text">My recharges</span></button>
            <button mat-menu-item [routerLink]="['/' + 'share-friends']" class="sharety">
             <img src="../../../../assets/images/app_icon_gray.png" alt=""/>
              <span class="menu_text">Share Business app</span></button>
            <button mat-menu-item [routerLink]="['/' + 'share-customer-app']" class="sharety">
               <img src="../../../../assets/images/market_icon_gray.png" alt=""/>
          <span class="menu_text">Share Customer app</span></button>
      <button mat-menu-item (click)="signOut()"><mat-icon class="material-icons-outlined" >logout</mat-icon>
        <span class="menu_text">Logout</span></button>
    </mat-menu>

    <mat-menu #menu1="matMenu">
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">person_add</mat-icon>
      <span class="menu_text">New booking</span></button>

      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">post_add</mat-icon>
      <span class="menu_text">Create invoice</span></button>

     
    </mat-menu>
    <!-- <button >
      <mat-icon class="material-icons-outlined">logout</mat-icon>
    </button> -->
    <!-- <div class="Create_header_btn d-none d-md-block">
      <button [matMenuTriggerFor]="menu5"  mat-flat-button color="primary"> <mat-icon>add</mat-icon> Create new</button>
   </div> -->


   <mat-menu #menu5="matMenu">
    <button mat-menu-item (click)="createNewBooking()" style="width: 220px;"> 
    <span class="menu_text"> 
      <mat-icon class="material-icons-outlined">person_add</mat-icon>
      New booking / query</span>
  </button>
    <button mat-menu-item (click)="createNewBill()">
      <mat-icon>post_add</mat-icon>
      <span class="menu_text"> Produce bill / invoice
      </span>
    </button>
    </mat-menu>

  </div>
  </div>
  </div>
</div>

   <!-- <mat-form-field appearance="outline" style="width: 150px;" >
      <mat-select [(ngModel)]="selectLanguage">
        <mat-option value="English" (click)="setLanguage('en')">
          English
        </mat-option>
        <mat-option value="हिंदी" (click)="setLanguage('hi')">
          हिंदी
        </mat-option>
        <mat-option value="Bengali" (click)="setLanguage('bn')">
          বাংলা
        </mat-option>
      </mat-select>
    </mat-form-field> -->